var element = document.querySelector('.sticky-bar');

if (element) {
	var isInViewport = function (elem) {
		var rect = elem.getBoundingClientRect();
		return (
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	var debounce = function (func, delay) {
		var timeout;
		return function () {
			var context = this;
			var args = arguments;
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				func.apply(context, args);
			}, delay);
		};
	};

	var handleScroll = function () {
		var targetSections = [
			document.querySelector('.drkroom-product-form'),
			document.querySelector('.hoox-footer'),
		];

		var isAnySectionInView = targetSections.some(function (section) {
			return section && isInViewport(section);
		});

		if (isAnySectionInView) {
			element.style.display = 'none';
		} else {
			element.style.display = 'block';
		}
	};

	var debouncedScroll = debounce(handleScroll, 50); // Adjust the debounce delay as needed

	window.addEventListener('scroll', debouncedScroll);
}
